import { citySchema } from "@/features/dashboard/types/city";
import { provinceSchema } from "@/features/dashboard/types/province";
import { regionSchema } from "@/features/dashboard/types/region";
import { z } from "zod";

export const counselSchema = z.object({
	first_name: z.string(),
	last_name: z.string(),
	middle_name: z.string(),
	email: z.any().nullable().optional(),
	region_code: z.string().nullable().optional(),
	region_name: z.string().nullable().optional(),
	province_name: z.string().nullable().optional(),
	city_name: z.string().nullable().optional(),
	province_code: z.string().nullable().optional(),
	city_code: z.string().nullable().optional(),
	barangay: z.string().nullable().optional(),
	address_1: z.string().nullable().optional(),
	address_2: z.string().nullable().optional(),
	zipcode: z.union([z.string(), z.number()]).nullable().optional(),
	province: provinceSchema.optional(),
	region: regionSchema.optional(),
	city: citySchema.optional(),
	law_firm: z.string().optional(),
	law_firm_email: z.string().optional(),
	mobile_number: z.string().optional(),
	landline: z.string().optional().nullable(),
	suffix: z.any().optional().nullable(),
	roll_number: z.any().optional().nullable(),
	action: z.any(),
});

export const counselFormSchema = z.object({
	roll_number: z.any().optional().nullable(),
	suffix: z.string().optional().nullable(),
	first_name: z.string().min(2, { message: "Required" }),
	last_name: z.string().min(2, { message: "Required" }),
	middle_name: z.string().optional().nullable(),
	region_name: z.string().nullable().optional(),
	province_name: z.string().nullable().optional(),
	city_name: z.string().nullable().optional(),
	defendants: z.any().optional(),
	reference_id: z.string().optional().nullable(),
	email: z.string().nullable().optional(),
	region_code: z.string().optional().nullable(),
	province_code: z.string().optional().nullable(),
	city_code: z.string().optional().nullable(),
	barangay: z.string().optional().nullable(),
	address_1: z.string().optional().nullable(),
	address_2: z.string().optional().nullable(),
	zipcode: z.union([z.string(), z.number()]).nullable().optional(),
	law_firm: z.string().optional().nullable(),
	law_firm_email: z.string().optional().nullable(),
	lawfirm_region_code: z.string().optional().nullable(),
	lawfirm_province_code: z.string().optional().nullable(),
	lawfirm_city_code: z.string().optional().nullable(),
	lawfirm_barangay: z.string().optional().nullable(),
	lawfirm_address_1: z.string().optional().nullable(),
	lawfirm_address_2: z.string().optional().nullable(),
	lawfirm_zipcode: z.any().optional().nullable(),
	mobile_number: z.string().optional().nullable(),
	landline: z.string().optional().nullable(),
	advanced_information: z.boolean().default(false),
});

export const editAddressSchema = z.object({
	suffix: z.string().optional().nullable(),
	first_name: z.string().optional().nullable(),
	id: z.string().min(1, { message: "Required" }),
	last_name: z.string().optional().nullable(),
	middle_name: z.string().optional().nullable(),
	corporation: z.string().optional().nullable(),
	defendants: z.any().optional(),
	reference_id: z.string().optional().nullable(),
	email: z.string().optional().nullable(),
	region_code: z.string().min(1, { message: "Required" }),
	province_code: z.string().min(1, { message: "Required" }),
	city_code: z.string().min(1, { message: "Required" }),
	barangay: z.string().min(1, { message: "Required" }),
	address_1: z.string().min(1, { message: "Required" }),
	address_2: z.string().optional().nullable(),
	zipcode: z.any().optional().nullable(),
	law_firm: z.string().optional().nullable(),
	law_firm_email: z.string().optional().nullable(),
	mobile_number: z.string().optional().nullable(),
	advanced_information: z.boolean().default(false),
});

export const editNameSchema = z.object({
	suffix: z.string().optional().nullable(),
	first_name: z.string().min(1, { message: "Required" }),
	id: z.string().min(1, { message: "Required" }),
	last_name: z.string().min(1, { message: "Required" }),
	middle_name: z.string().optional().nullable(),
	corporation: z.string().optional().nullable(),
});

export const editCorporationNameSchema = z.object({
	id: z.string().min(1, { message: "Required" }),
	corporation: z.string().min(1, { message: "Required" }),
	last_name: z.string().optional().nullable(),
	first_name: z.string().optional().nullable(),
	middle_name: z.string().optional().nullable(),
	suffix: z.string().optional().nullable(),
});

export type EditNameSchema = z.infer<typeof editNameSchema>;
export type EditCorporationNameSchema = z.infer<typeof editCorporationNameSchema>;
export type EditAddressSchema = z.infer<typeof editAddressSchema>;
export type CounselFormSchema = z.infer<typeof counselFormSchema>;
export type Counsel = z.infer<typeof counselSchema>;
